import React from "react";

import ozowLogo from "../../assets/logo_svgs/Ozow.svg";
import payfastLogo from "../../assets/logo_svgs/Payfast.svg";
import paystackLogo from "../../assets/logo_svgs/paystack.svg";
import peachPaymentsLogo from "../../assets/logo_svgs/peach_payements.svg";
import stitchMoneyLogo from "../../assets/logo_svgs/Stitic money.svg";
import debiCheckLogo from "../../assets/logo_svgs/Debit Check.svg";

const LOGOS = [
  { name: "PayFast", src: payfastLogo },
  { name: "Peach Payments", src: peachPaymentsLogo },
  { name: "Paystack", src: paystackLogo },
  { name: "Stitch Money", src: stitchMoneyLogo },
  { name: "Ozow", src: ozowLogo },
  { name: "DebiCheck", src: debiCheckLogo },
];

export default function CredibilityStrip() {
  return (
    <>
      <style>{`
        .credibility-strip {
          width: 100%;
          background: var(--bg-surface);
          border-top: 1px solid rgba(184,146,42,0.08);
          border-bottom: 1px solid rgba(184,146,42,0.08);
          padding: 0;
          display: flex;
          align-items: stretch;
          overflow: hidden;
          height: 64px;
        }

        .strip-label {
          flex-shrink: 0;
          display: flex;
          align-items: center;
          padding: 0 32px 0 40px;
          border-right: 1px solid rgba(184,146,42,0.10);
          white-space: nowrap;
          background: var(--bg-surface);
          position: relative;
          z-index: 2;
        }

        .strip-label-text {
          font-family: 'Fira Code', monospace;
          font-weight: 500;
          font-size: 10px;
          color: var(--text-muted);
          text-transform: uppercase;
          letter-spacing: 0.10em;
          line-height: 1.5;
          max-width: 220px;
        }

        .strip-carousel {
          flex: 1;
          overflow: hidden;
          display: flex;
          align-items: center;
          position: relative;
          min-width: 0;
        }

        .strip-carousel::before,
        .strip-carousel::after {
          content: '';
          position: absolute;
          top: 0;
          bottom: 0;
          width: 60px;
          z-index: 2;
          pointer-events: none;
        }

        .strip-carousel::before {
          left: 0;
          background: linear-gradient(
            to right,
            var(--bg-surface),
            transparent
          );
        }

        .strip-carousel::after {
          right: 0;
          background: linear-gradient(
            to left,
            var(--bg-surface),
            transparent
          );
        }

        .strip-track {
          display: flex;
          align-items: center;
          gap: 0;
          width: max-content;
          animation: stripScroll 32s linear infinite;
        }

        .strip-track:hover {
          animation-play-state: paused;
        }

        @keyframes stripScroll {
          from { transform: translateX(0); }
          to   { transform: translateX(-50%); }
        }

        .strip-logo-item {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 32px;
          height: 64px;
          border-right: 1px solid rgba(255,255,255,0.04);
          flex-shrink: 0;
          transition: background 0.2s ease, transform 0.2s ease;
          cursor: default;
        }

        .strip-logo-item:hover {
          background: rgba(184,146,42,0.04);
        }

        .strip-logo-img {
          height: 20px;
          width: auto;
          max-width: 120px;
          display: block;
          opacity: 0.7;
          transition: opacity 0.2s ease, transform 0.2s ease, filter 0.2s ease;
          filter: grayscale(1) invert(1) brightness(1.9) contrast(1.05);
          mix-blend-mode: screen;
        }

        .strip-logo-item:hover .strip-logo-img {
          opacity: 0.95;
          transform: translateY(-1px);
          filter: grayscale(1) invert(1) brightness(2.2) contrast(1.1);
        }

        .logo-placeholder {
          height: 18px;
          display: flex;
          align-items: center;
          font-family: var(--font-mono);
          font-size: 11px;
          font-weight: 500;
          color: rgba(244,244,245,0.25);
          letter-spacing: 0.04em;
          white-space: nowrap;
        }

        /* Mobile responsive */
        @media (max-width: 639px) {
          .credibility-strip {
            flex-direction: column;
            align-items: stretch;
            height: auto;
          }

          .strip-label {
            display: flex;
            justify-content: center;
            padding: 10px 16px;
            border-right: none;
            border-bottom: 1px solid rgba(184,146,42,0.10);
            white-space: normal;
            text-align: center;
          }

          .strip-label-text {
            max-width: none;
            text-align: center;
          }

          .strip-carousel {
            height: 52px;
          }

          .strip-carousel::before {
            display: none;
          }

          .strip-logo-item {
            padding: 0 22px;
            height: 52px;
          }

          .strip-track {
            animation-duration: 22s;
          }
        }
      `}</style>

      <div className="credibility-strip">
        <div className="strip-label">
          <div
            className="strip-label-text"
            style={{
              fontFamily: '"Palatino Linotype", "Book Antiqua", Palatino, serif',
              color: "#ffffff",
            }}
          >
            POWERED BY AFRICA&apos;S<br />
            LEADING PAYMENT INFRASTRUCTURE
          </div>
        </div>

        <div className="strip-carousel">
          <div className="strip-track">
            {LOGOS.map((logo, index) => (
              <div key={`first-${index}`} className="strip-logo-item">
                <img className="strip-logo-img" src={logo.src} alt={logo.name} />
              </div>
            ))}

            {LOGOS.map((logo, index) => (
              <div key={`second-${index}`} className="strip-logo-item">
                <img className="strip-logo-img" src={logo.src} alt={logo.name} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
